import script from "./BotsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./BotsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./BotsDropdown.vue?vue&type=style&index=0&id=68a9053c&scoped=true&lang=css"
import "./BotsDropdown.vue?vue&type=style&index=1&id=68a9053c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a9053c"]])

export default __exports__